import styled from "styled-components";

const MarketContainer = styled.div``;
const MarketItems = styled.div`
    display: flex;
`;

export{
    MarketContainer,
    MarketItems,
}